import { render, staticRenderFns } from "./ExternalRedirectView.vue?vue&type=template&id=8323b64c&scoped=true"
import script from "./ExternalRedirectView.vue?vue&type=script&lang=ts"
export * from "./ExternalRedirectView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8323b64c",
  null
  
)

export default component.exports